import React, { FC } from 'react';
import './_PolicyInput.css';

type Props = {
  type?: string;
    placeholder?: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
    className?: string;
    disabled?: boolean;
    name?: string;
    error?: boolean;

} & React.InputHTMLAttributes<HTMLInputElement>

const PolicyInput: FC<Props> = ({
  type,
    placeholder,
    value,
    onChange,
    className,
    disabled,
    name,
    ...props
}) => {
  return (

    // make input global component
    <input type={type ? type : 'text'}
    name={name}
    className={className?className:'policy-input'}
    placeholder={placeholder? placeholder:''}
    value={value}
    onChange={(e)=>onChange(e)}
    onBlur={props.onBlur? (e)=>props.onBlur!(e):undefined}
    disabled={disabled ? disabled:false}
    {...props} />
  )
}

export default PolicyInput